<template lang="pug">
div
  Form(:data="confirmationPlanning", :isSubmitting="isSubmitting", :isSelectMultiple="false", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useConfirmationPlanningEdit from './useConfirmationPlanningEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { update, show, confirmationPlanning, isSubmitting } = useConfirmationPlanningEdit()

    onMounted(show)

    return {
      confirmationPlanning,
      update,
      isSubmitting,
    }
  },
}
</script>
